import { cn } from '@/lib/utils';
import { BadgeCheck, Clock } from 'lucide-react';
import React from 'react';

interface VerifiedBadgeProps {
  /** true = verified (coral), false = pending review (amber) */
  verified?: boolean;
  className?: string;
}

/**
 * Core trust signal of Creve. Reused anywhere a vendor's identity status
 * needs to be shown — vendor cards, listings, profile headers, etc.
 */
export const VerifiedBadge: React.FC<VerifiedBadgeProps> = ({
  verified = true,
  className,
}) => {
  if (verified) {
    return (
      <span
        className={cn(
          'inline-flex items-center gap-1 rounded-full bg-secondary px-2.5 py-1 text-xs font-semibold text-primary',
          className
        )}
      >
        <BadgeCheck className='h-3.5 w-3.5' strokeWidth={2.25} />
        Verified
      </span>
    );
  }

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-accent/15 px-2.5 py-1 text-xs font-semibold text-accent-foreground',
        className
      )}
    >
      <Clock className='h-3.5 w-3.5' strokeWidth={2.25} />
      Pending review
    </span>
  );
};

export default VerifiedBadge;
